import { ensureTab, appendRow, getRows, updateRow, findRowIndexById } from '../lib/googleSheets';

const TAB = 'Games';
const HEADERS = [
  'id', 'gamePk', 'slug', 'date', 'venue',
  'awayName', 'awayAbbr', 'awayScore', 'awayWins', 'awayLosses',
  'homeName', 'homeAbbr', 'homeScore', 'homeWins', 'homeLosses',
  'winnerId', 'winnerName', 'loserId', 'loserName', 'saverId', 'saverName',
  'status', 'savedAt', 'created_at', 'updated_at',
];

const generateId = () => (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).substr(2);

const toRow = (g) => {
  const now = new Date().toISOString();
  return [
    g.id || generateId(),
    String(g.gamePk || ''),
    g.slug || '',
    g.date || '',
    g.venue || '',
    g.away?.name || '',
    g.away?.abbr || '',
    String(g.away?.score ?? ''),
    String(g.away?.record?.wins ?? ''),
    String(g.away?.record?.losses ?? ''),
    g.home?.name || '',
    g.home?.abbr || '',
    String(g.home?.score ?? ''),
    String(g.home?.record?.wins ?? ''),
    String(g.home?.record?.losses ?? ''),
    String(g.decisions?.winner?.id ?? ''),
    g.decisions?.winner?.fullName || '',
    String(g.decisions?.loser?.id ?? ''),
    g.decisions?.loser?.fullName || '',
    String(g.decisions?.save?.id ?? ''),
    g.decisions?.save?.fullName || '',
    g.status || 'Final',
    g.savedAt || now,
    now,
    now,
  ];
};

const fromRow = (r) => {
  const obj = {};
  HEADERS.forEach((h, i) => (obj[h] = r[i] ?? ''));
  
  return {
    ...obj,
    away: {
      name: obj.awayName,
      abbr: obj.awayAbbr,
      score: obj.awayScore,
      record: { wins: obj.awayWins, losses: obj.awayLosses }
    },
    home: {
      name: obj.homeName,
      abbr: obj.homeAbbr,
      score: obj.homeScore,
      record: { wins: obj.homeWins, losses: obj.homeLosses }
    },
    decisions: {
      winner: { id: obj.winnerId, fullName: obj.winnerName },
      loser: { id: obj.loserId, fullName: obj.loserName },
      save: { id: obj.saverId, fullName: obj.saverName },
    }
  };
};

export async function saveGame(game) {
  await ensureTab(TAB, HEADERS);
  
  // Prevent duplicate entries
  const existing = await getGameByPk(game.gamePk);
  if (existing) return existing.id;

  const row = toRow(game);
  await appendRow(`${TAB}!A:Z`, row);
  return row[0];
}

export async function getGames() {
  await ensureTab(TAB, HEADERS);
  const rows = await getRows(`${TAB}!A2:Z`);
  return rows.map(fromRow);
}

export async function getGameById(id) {
  const games = await getGames();
  return games.find((g) => g.id === id || g.gamePk === String(id));
}

export async function getGameByPk(gamePk) {
  const games = await getGames();
  return games.find((g) => g.gamePk === String(gamePk));
}

export async function updateGame(id, updates) {
  await ensureTab(TAB, HEADERS);
  const sheetRow = await findRowIndexById(TAB, id);
  if (sheetRow < 0) throw new Error(`game not found: ${id}`);

  const existing = await getRows(`${TAB}!A${sheetRow}:Z${sheetRow}`);
  const current = fromRow(existing[0] || []);
  const merged = { ...current, ...updates, updated_at: new Date().toISOString() };

  const row = toRow(merged);
  await updateRow(`${TAB}!A${sheetRow}:Z${sheetRow}`, row);
  return merged;
}